import { Card, CardBody } from '@components/card/card';
import NeatixModal from '@components/Modal/NeatixModal';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddVacationBalance from './AddVacationBalance';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import {
  getPerAccrualBalanceByPersonIdList,
  getAccrualBalanceByPersonId
} from '@store/HR/Person/PersonAccrualBalanceSlice';
import Loading from '@components/Shared/Loader/Loading';

// تعريف الـ Types

interface Props {
  personId: string;
}

const VacationBalance: React.FC<Props> = ({ personId }) => {
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [currentBalance, setCurrentBalance] = useState<number>(0);
  const [totalBalance, setTotalBalance] = useState<number>(0);
  const dispatch = useAppDispatch();

  const { PerAccrualBalanceList: data, loading, error } = useAppSelector(s => s.PersonAccrualBalance);

  console.log(data);

  useEffect(() => {
    dispatch(getPerAccrualBalanceByPersonIdList(personId));
  }, [dispatch, personId]);

  useEffect(() => {
    const getCurrentBalance = async () => {
      const res = await dispatch(getAccrualBalanceByPersonId(personId)).unwrap();
      if (res.succeeded === true) {
        setCurrentBalance(res.data);
      } else {
        setCurrentBalance(0);
      }
    };

    getCurrentBalance();
  }, [dispatch, personId]);

  const handleAddSuccess = (): void => {
    setShowAddModal(false);
    // إعادة تحميل البيانات بعد الإضافة
    // fetchVacationData();
  };

  const usedBalance: number = totalBalance - currentBalance;

  return (
    <Loading loading={loading} error={error}>
      <div>
        {/* بطاقات الرصيد */}
        <div className='row mb-4'>
          <div className='col-md-4'>
            <Card className='bg-primary bg-opacity-10 border-primary border-0'>
              <CardBody className='text-center py-4'>
                <i className='fa fa-wallet fa-2x text-primary mb-3'></i>
                <h3 className='text-primary mb-1'>{currentBalance}</h3>
                <p className='text-muted mb-0'>الرصيد الحالي</p>
              </CardBody>
            </Card>
          </div>
          <div className='col-md-4'>
            <Card className='bg-success bg-opacity-10 border-success border-0'>
              <CardBody className='text-center py-4'>
                <i className='fa fa-chart-line fa-2x text-success mb-3'></i>
                <h3 className='text-success mb-1'>{totalBalance}</h3>
                <p className='text-muted mb-0'>إجمالي الرصيد</p>
              </CardBody>
            </Card>
          </div>
          <div className='col-md-4'>
            <Card className='bg-warning bg-opacity-10 border-warning border-0'>
              <CardBody className='text-center py-4'>
                <i className='fa fa-clock fa-2x text-warning mb-3'></i>
                {/* <h3 className='text-warning mb-1'>{usedBalance}</h3> */}
                <h3 className='text-warning mb-1'>00</h3>
                <p className='text-muted mb-0'>الرصيد المستخدم</p>
              </CardBody>
            </Card>
          </div>
        </div>

        {/* رأس الجدول مع زر الإضافة */}
        <div className='d-flex justify-content-between align-items-center mb-3'>
          <h5 className='mb-0'>
            <i className='fa fa-history me-2 text-theme'></i>
            سجل الرصيد
          </h5>
          <button className='btn btn-theme' onClick={() => setShowAddModal(true)}>
            <i className='fa fa-plus me-2'></i>
            إضافة رصيد
          </button>
        </div>

        {/* جدول سجل الرصيد */}
        {/* <div className='table-responsive rounded-3 border shadow-sm'>
          <table className='table table-hover mb-0'>
            <thead className='table-theme'>
              <tr>
                <th scope='col'>التاريخ</th>
                <th scope='col'>القيمة</th>
                <th scope='col'>النوع</th>
                <th scope='col'>الفترة</th>
                <th scope='col'>الوصف</th>
                <th scope='col'>الرصيد بعد</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map(item => (
                  <tr key={item.id}>
                    <td className='align-middle'>
                      <strong>{item.startDate?.split('T')[0]}</strong>
                    </td>
                    <td className='align-middle'>
                      <span className={`badge ${item.increaseFlag ? 'bg-success' : 'bg-danger'} fs-6`}>
                        {item.increaseFlag ? '+' : '-'}
                        {item.value}
                      </span>
                    </td>
                    <td className='align-middle'>
                      <span className={`badge ${item.increaseFlag ? 'bg-success' : 'bg-danger'}`}>
                        {item.increaseFlag ? 'إضافة' : 'خصم'}
                      </span>
                    </td>
                    <td className='align-middle'>
                      <small>
                        <span className='text-muted'>من</span> {item.startDate?.split('T')[0]} <br />
                        <span className='text-muted'>إلى</span> {item.endDate?.split('T')[0]}
                      </small>
                    </td>
                    <td className='align-middle'>{item.description}</td>
                    <td className='align-middle'>
                      <strong className='text-theme fs-6'>{item.balanceAfter}</strong>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className='text-center py-4 text-muted'>
                    <i className='fa fa-inbox fa-2x mb-2'></i>
                    <br />
                    لا توجد سجلات للرصيد
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div> */}
        <Card className='mb-4'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <h6 className='mb-0'>
              <i className='fas fa-history me-2'></i>
              سجل رصيد الإجازات
              <span className='badge bg-primary ms-2'>سجل العمليات</span>
            </h6>
            <div>
              <span className='badge bg-theme me-2'>إجمالي العمليات: {data.length}</span>
              <span className='badge bg-success'>الرصيد الحالي: {currentBalance.toLocaleString()}</span>
            </div>
          </div>

          <div className='card-body p-0'>
            <div className='table-responsive'>
              <table className='table table-hover mb-0'>
                <thead className='table-actived fw-bold'>
                  <tr>
                    <th className='text-center small'>التاريخ</th>
                    <th className='text-center small'>القيمة</th>
                    <th className='text-center small'>النوع</th>
                    <th className='text-center small'>الفترة</th>
                    <th className='text-center small'>الوصف</th>
                    <th className='text-center small'>الرصيد بعد</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map(item => (
                      <tr key={item.id}>
                        <td className='text-center align-middle'>
                          <strong>{item.startDate?.split('T')[0]}</strong>
                        </td>
                        <td className='text-center align-middle'>
                          <span className={`badge ${item.increaseFlag ? 'bg-success' : 'bg-danger'} fs-6`}>
                            {item.increaseFlag ? '+' : '-'}
                            {item.value}
                          </span>
                        </td>
                        <td className='text-center align-middle'>
                          <span className={`badge ${item.increaseFlag ? 'bg-success' : 'bg-danger'}`}>
                            {item.increaseFlag ? 'إضافة' : 'خصم'}
                          </span>
                        </td>
                        <td className='text-center align-middle'>
                          <small>
                            <span className='text-muted'>من</span> {item.startDate?.split('T')[0]} <br />
                            <span className='text-muted'>إلى</span> {item.endDate?.split('T')[0]}
                          </small>
                        </td>
                        <td className='text-center align-middle'>{item.description}</td>
                        <td className='text-center align-middle'>
                          <strong className='text-theme fs-6'>{item.balanceAfter}</strong>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6} className='text-center py-4 text-muted'>
                        <i className='fa fa-inbox fa-2x mb-2'></i>
                        <br />
                        لا توجد سجلات للرصيد
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className='card-footer d-flex justify-content-between align-items-center'>
            <div className='text-muted small'>
              عرض {data.length} من {data.length} عملية
            </div>
            <div className='text-theme fw-bold'>الرصيد الحالي: {currentBalance.toLocaleString()} يوم</div>
          </div>
        </Card>

        {/* مودال إضافة الرصيد */}
        <NeatixModal show={showAddModal} setShow={setShowAddModal} size='lg' title='إضافة رصيد إجازات' centered>
          <AddVacationBalance
            personId={personId}
            onSuccess={handleAddSuccess}
            onCancel={() => setShowAddModal(false)}
          />
        </NeatixModal>
      </div>
    </Loading>
  );
};

export default VacationBalance;
